import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';
import { CommonService } from '../services/common.service';

@Component({
	selector: 'app-admin',
	templateUrl: './admin.component.html',
	styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

	admPageObj:any = "curr";

	logi_user:any;

	mainData:any = [];
	orderList:any;

	autoOrder:any;
	autoProgress:any = 0;

	pcLeftCss:any;
	mobileLeftCss:any;
	appLeftCss:any;

	constructor(
		private http: HttpClient,
		private router: Router,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) { }

	ngOnInit() {
		this.getMainData();
		this.getOrderList();

		this.autoOrder = setInterval(() => {
			this.autoProgress = this.autoProgress + 10;
			if( this.autoProgress > 100 )
			{
				this.autoProgress = 0;
				this.getOrderList();
			}
		}, 1000);
	}

	async getMainData() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_partner", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/admin.main.php', formData).subscribe((response) => {
			if( response['code'] == 9000 )
			{

			}
			else
			{
				this.mainData = response['data'];

				if( response['data']['pc_left'] <= 5 ){ this.pcLeftCss = " imminent"; }
				if( response['data']['mobile_left'] <= 5 ){ this.mobileLeftCss = " imminent"; }
				if( response['data']['app_left'] <= 5 ){ this.appLeftCss = " imminent"; }

				if( response['data']['pc_left'] < 0 || response['data']['mobile_left'] < 0 || response['data']['app_left'] < 0 )
				{
					this.router.navigate(['/not-use']);
				}
			}
		});
	}

	async getOrderList() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("page", 1);
		formData.append("listnum", 10);

		this.http.post(this.env.API_URL + 'api/order.list2.php', formData).subscribe((response) => {
			this.orderList = response['list'];
		});
	}
}
